import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "episode-card__text-box" }
const _hoisted_2 = { class: "episode-card__title" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "episode-card__actions-box" }
const _hoisted_5 = { class: "episode-card__info-box" }
const _hoisted_6 = { class: "episode-card__date" }
const _hoisted_7 = {
  key: 0,
  class: "episode-card__controls"
}

import type { RouteLocationRaw } from 'vue-router'
import type { EpisodeListItem } from '@/models/interfaces'
import FavoriteFlag from '@/app/components/listing/FavoriteFlag.vue'
import DocLibraryMenu from '@/app/components/doc/DocLibraryMenu.vue'
import DocBadges from '@/app/components/doc/DocBadges.vue'
import DocMoreMenu from '@/app/components/doc/DocMoreMenu.vue'
import DocProgressBar from '@/app/components/doc/DocProgressBar.vue'
import DocTypeBadge from '@/app/components/doc/DocTypeBadge.vue'
import SaveButton from '@/app/components/doc/SaveButton.vue'
import TimeEstimate from '@/app/components/doc/TimeEstimate.vue'
import EpisodeCardCover from './EpisodeCardCover.vue'
import { formatDate } from '@/helpers/time'
import type { PodcastEpisodesView } from '@/models/docs.list.podcasts.episodes'
import { IS_PRERENDERING } from '@/init/settings'
import { assertNotNull } from '@/helpers/typing'
import { saveForLater20321Treatment } from '@/services/ab/experiments'


export default /*@__PURE__*/_defineComponent({
  __name: 'EpisodeCard',
  props: {
    doc: {},
    mobileVariant: { default: 'horizontal' },
    link: {},
    view: {}
  },
  setup(__props: any) {

const props = __props

// Public podcast pages don't pass a view and should use the old design.
const showNewSaveDesign = !!props.view && saveForLater20321Treatment()

function variantClass(): string {
  return props.mobileVariant === 'horizontal'
    ? 'episode-card--horizontal'
    : 'episode-card--vertical'
}

function subtitle(): string {
  const episode = props.doc
  const podcast = 'doc_group' in episode && episode.doc_group

  if (podcast && props.view?.showPodcastAsSubtitle()) {
    return `<p>${podcast.title}</p>`
  }
  return episode.blurb || ''
}

function episodeLink(): Record<string, unknown> | RouteLocationRaw {
  const link = props.view?.startLinkParams(props.doc) || props.link
  return assertNotNull(link)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["episode-card", [variantClass(), { 'episode-card--20321B': _unref(showNewSaveDesign) }]])
  }, [
    (_unref(showNewSaveDesign) && __props.view?.hasUserData(__props.doc))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(SaveButton, {
            class: "episode-card__save-button",
            doc: __props.doc,
            docsView: __props.view
          }, null, 8, ["doc", "docsView"]),
          _createVNode(DocMoreMenu, {
            class: _normalizeClass(["episode-card__more-menu", {
          'episode-card__more-menu--above-progress': __props.doc.user?.progress,
        }]),
            doc: __props.doc,
            docsView: __props.view
          }, null, 8, ["class", "doc", "docsView"])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_router_link, {
      to: episodeLink(),
      class: "episode-card__link"
    }, {
      default: _withCtx(() => [
        (_unref(showNewSaveDesign))
          ? (_openBlock(), _createBlock(DocTypeBadge, {
              key: 0,
              docType: "podcast_episode"
            }))
          : _createCommentVNode("", true),
        _createVNode(EpisodeCardCover, { doc: __props.doc }, null, 8, ["doc"]),
        (_unref(showNewSaveDesign))
          ? (_openBlock(), _createBlock(DocProgressBar, {
              key: 1,
              class: "episode-card__progress",
              progress: __props.doc.user?.progress
            }, null, 8, ["progress"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.doc.title), 1),
          _createElementVNode("div", {
            class: "episode-card__subtitle",
            innerHTML: subtitle()
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_unref(showNewSaveDesign))
                ? (_openBlock(), _createBlock(DocBadges, {
                    key: 0,
                    doc: __props.doc
                  }, null, 8, ["doc"]))
                : (_openBlock(), _createBlock(TimeEstimate, {
                    key: 1,
                    doc: __props.doc
                  }, null, 8, ["doc"])),
              _createElementVNode("div", _hoisted_6, _toDisplayString(__props.doc.original_publish_date
                  ? _unref(formatDate)(__props.doc.original_publish_date)
                  : ''), 1)
            ]),
            (
              !_unref(showNewSaveDesign) && !_unref(IS_PRERENDERING) && __props.view?.hasUserData(__props.doc)
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (__props.view.showActionsButton(__props.doc))
                    ? (_openBlock(), _createBlock(DocLibraryMenu, {
                        key: 0,
                        class: "episode-card__actions",
                        docsView: __props.view,
                        doc: __props.doc,
                        position: "right"
                      }, null, 8, ["docsView", "doc"]))
                    : _createCommentVNode("", true),
                  _createVNode(FavoriteFlag, {
                    class: "books__collection collection collection--book-card episode-card__favorite",
                    doc: __props.doc,
                    docsView: __props.view
                  }, null, 8, ["doc", "docsView"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_unref(showNewSaveDesign) && __props.doc.user?.progress)
            ? (_openBlock(), _createBlock(DocProgressBar, {
                key: 0,
                class: "episode-card__progress--mobile",
                progress: __props.doc.user.progress
              }, null, 8, ["progress"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ], 2))
}
}

})